import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
import EzTable from "../../common/EzTable";
import { EzToast, TOAST_SEVERITY } from "../../common/EzToast";
import EzNotFound from "../../common/EzNotFound";
import { COMPLIANCE_DATE_DATA_KEY } from "../../Redux/Reducers/compliance";
import Comingsoonpage from "../../common/Comingsoon";
const getIconPath = (imgPathDelta = "/no-record.png") =>
  process.env.PUBLIC_URL + imgPathDelta;
const TruckCare = (props) => {
  const {
    tableData,
    paginationInfo,
    screenPermissions,
    createTransaction,
    isPageLevelError,
  } = props;

  const [areFiltersVisible, toggleFilterState] = useState(false);

  const renderPageHeaderSection = () => {
    return (
       <div className="make-relative">
       <div className="" style={{ display: "flex", justifyContent: "space-between",alignItems:"center" }}>
         <div>
          <div className="ml-3">
          <h4>Truck Care</h4>
          </div>
           {/* <Button
             label={areFiltersVisible ? "Advanced Filter" : "Advanced Filter"}
             icon={areFiltersVisible ? "pi pi-filter-slash" : "pi pi-filter"}
             className={`p-button-text p-button-secondary`}
             onClick={() => {
               toggleFilterState(!areFiltersVisible);
             }}
           /> */}
         </div>
         {/* <Button
           label={"Exports Selected"}
           className={` p-button-raised`}
           style={{ borderRadius: "10px" , }}
           onClick={createTransaction}
         /> */}
       </div>
     </div>
    );
  };
  const shouldRenderFullPageError = () => isPageLevelError;
  const shouldRenderComplianceRecords = () => tableData?.columns?.length > 0;
  const shouldRenderNotFoundView = () =>
    !shouldRenderComplianceRecords() && !shouldRenderFullPageError();
  const filters = {
    global: { value: null },
    type: { filterKey: "type.name", value: null },
    cat: { filterKey: "cat.name", value: null },
    object_type: { filterKey: "object_type.first", value: null },
    desc: { filterKey: "desc", value: null },
    due_date: { filterKey: "due_date", value: null },
    cmplnc_status: { filterKey: "cmplnc_status.name", value: null },
  };
  
  const tableProps = {
    areFiltersVisible,
    columns: tableData?.columns,
    paginationInfo,
    screenPermissions,
    value: tableData?.rows,
    emptyMessage: "No Reporting found.",
    filters,
    loading: false,
    showMoreActions: false,
    sortField: COMPLIANCE_DATE_DATA_KEY,
  };
  return (
    <>
      <div className="paddingbox">
        <div className="containerbox">
          {renderPageHeaderSection()}
          <div className="mTop15">
            {shouldRenderFullPageError() && (
              <EzNotFound
                messageStyle={{ marginLeft: "-70px" }}
                bgImgUrl={getIconPath("something-broke.png")}
                message={"Oops! Something broke, we are working on a fix."}
              />
            )}
           
              <Row>
                <Col md={12}>
                
                  <Comingsoonpage />
                  {/* <EzTable {...tableProps} /> */}
                </Col>
              </Row>
           
            {shouldRenderNotFoundView() && (
              <EzNotFound
                bgImgUrl={getIconPath()}
                message={"No Truck Care records to show"}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default TruckCare;
